import { render } from "./TransferOrderDetail.vue?vue&type=template&id=94718836&scoped=true"
import script from "./TransferOrderDetail.vue?vue&type=script&lang=js"
export * from "./TransferOrderDetail.vue?vue&type=script&lang=js"

import "./TransferOrderDetail.vue?vue&type=style&index=0&id=94718836&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94718836"],['__file',"src/views/h5/common/stock/transfer/TransferOrderDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "94718836"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('94718836', __exports__)) {
    api.reload('94718836', __exports__)
  }
  
  module.hot.accept("./TransferOrderDetail.vue?vue&type=template&id=94718836&scoped=true", () => {
    api.rerender('94718836', render)
  })

}


export default __exports__